import React from "react";
import {
  DataGroup,
  DataType,
  LinkType,
  NODE_SOURCE_LIST_NAME,
  NodeType,
  SharedDataType,
  SubTypeColor,
} from "./model";
import { getCookie } from "../services/utils";

export type RangeListProps = {
  field: string;
  min: number;
  max: number;
};

export interface GraphContextIF {
  clusterData: any;
  setClusterData: (data: any) => void;
  nodeData: any;
  setNodeData: (data: any) => void;
  sharedData: SharedDataType;
  setSharedData: (data: SharedDataType) => void;
  colorList: SubTypeColor[];
  setColorList: (data: SubTypeColor[]) => void;
  rangeList: RangeListProps[];
  setRangeList: (data: RangeListProps[]) => void;
}
export const GraphContext = React.createContext({} as GraphContextIF);

export const fetchData = async (url: string, type: DataGroup) => {
  const data = await fetch(url);
  const lines = (await data.text()).split("\n");
  const nodes: DataType[] = [];
  let headers: string[] = [];
  lines.forEach((line, i) => {
    if (i === 0) {
      headers = line.split("\t");
      headers = headers.map((header) => header.trim().toLowerCase());
    } else {
      const parts = line.split("\t");
      if (parts.length < headers.length) {
        console.log(
          "data incorrect parts: ",
          parts.length,
          "headers: ",
          headers.length
        );
      } else {
        const obj: any = {};
        for (let j = 0; j < parts.length; j++) {
          obj[headers[j]] = parts[j];
        }
        if (type === DataGroup.NODE) {
          obj.id = parts[0];
        } else {
          obj.source = parts[0];
          obj.target = parts[1];
        }
        nodes.push(obj);
      }
    }
  });
  return { headers, nodes };
};

export const updateNodesData = (
  nodesData: NodeType[],
  linksData: LinkType[]
): SubTypeColor[] => {
  const colors: { [k: string]: SubTypeColor } = {};
  for (let i = 0; i < nodesData.length; i++) {
    const subType = nodesData[i]["subtype"] as string;
    if (!colors[subType]) {
      colors[subType] = {
        subType,
        color: nodesData[i]["nodecolor"] as string,
        count: 1,
      };
    } else {
      colors[subType]["count"] += 1;
    }
    const node = nodesData[i];
    node[NODE_SOURCE_LIST_NAME] = [];
    const links = linksData
      .filter((link) => link.target === node.id)
      .map((link) => link.source);
    node[NODE_SOURCE_LIST_NAME].push(...links);
  }
  const colorList = Object.values(colors).sort((a, b) => b.count - a.count);
  return colorList;
};

export const fetchApi = async (
  urlWithoutHost: string,
  postData?: string | Object,
  returnRawResponse?: boolean
) => {
  const baseUrl = "";
  const url = baseUrl + urlWithoutHost;
  console.log("========fetchData", url);

  const option = {
    method: postData ? "POST" : "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include" as RequestCredentials,
    body: postData
      ? typeof postData === "string"
        ? postData
        : JSON.stringify(postData)
      : undefined,
  };
  const response = await fetch(url, option);
  if (returnRawResponse) {
    return response;
  }
  const text = await response.text();
  try {
    const json = JSON.parse(text);
    return { json };
  } catch (e) {
    return { text };
  }
};


export interface User {
    email: string;
    block: string;
}
export interface UserCookie {
  email: string;
  admin: string;
}
export const getUserCookie = () => {
  const userToken = getCookie("userData");
  if (userToken) {
    try {
      const user: UserCookie = JSON.parse(userToken);
      return user;
    } catch (e) {
      console.log("getUserCookie error", e);
    }
  }
  return null;
};
